import {RadioGroupField} from "../../../components/RadioGroupField";
import {WebsiteType} from "../../../types/common";
import {useBannerType} from "../../../types/hooks/useBannerType";
import {BannerType} from "../../../types/banner";

interface Props {
    bannerType: BannerType;
    setBannerType: (_: BannerType) => void;
    websiteType: WebsiteType;
}

export default function BannerTypeField({bannerType, setBannerType, websiteType}: Props) {
    const {getBannerTypeLabel} = useBannerType();

    let newBannerType: BannerType[];

    switch (websiteType) {
        case WebsiteType.KPASS:
            newBannerType = [BannerType.KOREAN, BannerType.ENGLISH, BannerType.MONGOLIAN];break;
        case WebsiteType.DCAS:
            newBannerType = [BannerType.KOREAN, BannerType.ENGLISH, BannerType.TAIWAN, BannerType.MONGOLIAN];break;
        case WebsiteType.GROUP_MEMBER:
            newBannerType = [BannerType.KOREAN, BannerType.ENGLISH, BannerType.MONGOLIAN];
            break;
    }

    return (
        <>
            <RadioGroupField enumValues={newBannerType}
                             getLabel={getBannerTypeLabel}
                             value={bannerType} setValue={setBannerType}
                             groupName={"bannerType"} isRequired={true}
            />
        </>
    );
};